import { render, staticRenderFns } from "./serviceAllowance.vue?vue&type=template&id=5358afee&scoped=true"
import script from "./serviceAllowance.vue?vue&type=script&lang=js"
export * from "./serviceAllowance.vue?vue&type=script&lang=js"
import style0 from "./serviceAllowance.vue?vue&type=style&index=0&id=5358afee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358afee",
  null
  
)

export default component.exports